import { render, staticRenderFns } from "./IndividualRecords.vue?vue&type=template&id=7813639e&"
import script from "./IndividualRecords.vue?vue&type=script&lang=js&"
export * from "./IndividualRecords.vue?vue&type=script&lang=js&"
import style0 from "./IndividualRecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports